import { PageConfig } from '@app/Modules/type';
import AssignListeNoire from './Custom/AssignListeNoire';
import ValidateListeNoire from './Custom/ValidateListNoire';
import ValidatePotentiels from './Custom/ValidatePotentiels';
import ValidateReconductions from './Custom/ValidateReconductions';
import AssignReconductions from './Custom/AssignReconductions';
import AssignPotentiels from './Custom/AssignPotentiels';
import ArchivePotentiels from './Custom/ArchivePotentiels';
import SetToTreatPotentiels from './Custom/SetToTreatPotentiels';

type props = {
    pageConfig: PageConfig;
    selected: string[];
    onSuccess: () => void;
    open: boolean;
    onClose: () => void;
    actionType?: 'validate' | 'archive' | 'setToTreat' | 'assign';
};

// List of pages how get some custom identifier
const identifierForCustomAction = [
    'listeNoireViewSchema',
    'listeNoireUserAdminSchema',
    'potentielsParrainagesSchema', // Ajout pour potentiels parrainages
];

const UpdateManyCustom = ({
    pageConfig,
    selected,
    onSuccess,
    open,
    onClose,
    actionType = 'validate',
}: props) => {
    // Validation groupée potentiels parrainages et reconductions
    return (
        <>
            {pageConfig.config.indentifier ===
                'potentielsParrainagesSchema' &&
                actionType === 'validate' && (
                <ValidatePotentiels
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier ===
                'potentielsParrainagesSchema' &&
                actionType === 'archive' && (
                <ArchivePotentiels
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier ===
                'potentielsParrainagesSchema' &&
                actionType === 'setToTreat' && (
                <SetToTreatPotentiels
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier ===
                'potentielsParrainagesSchema' &&
                actionType === 'assign' && (
                <AssignPotentiels
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier ===
                'parrainagesReconductionsSchema' && (
                <ValidateReconductions
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier === identifierForCustomAction[0] && (
                <AssignListeNoire
                    pageConfig={pageConfig}
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier === identifierForCustomAction[1] && (
                <ValidateListeNoire
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
            {pageConfig.config.indentifier === 'reconductionsPourImpressionSchema' && (
                <AssignReconductions
                    idToUpdate={selected.map((id) => parseInt(id))}
                    onSuccess={onSuccess}
                    open={open}
                    onClose={onClose}
                />
            )}
        </>
    );
};

export default UpdateManyCustom;
